/* global Config */

// Vendor Libs
import React, {useState} from 'react';
import cookie from 'react-cookies';
import {Link, useLocation} from '@reach/router';
import {parse} from 'query-string';

// Material UI
import {Button, Container, CssBaseline, IconButton, InputAdornment, Tooltip, Typography} from '@material-ui/core';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import {makeStyles} from '@material-ui/core/styles';

// Material Design Icons
import EyeOff from 'mdi-material-ui/EyeOff';

// Dish Tech React
import {InputTextField} from '@dishtech-react/core';

// Images
import logo from './ripple-logo.svg';

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
        },
    },
    card: {
        margin: 'auto',
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    eye: {
        cursor: 'pointer',
        color: '#3f51b5',
    },
    error: {
        color: 'red',
    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        marginTop: theme.spacing(1),
    },
    inputField: {
        fullWidth: true,
        margin: 'normal',
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const Login = () => {
    const classes = useStyles();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [masked, setMasked] = useState(true);
    const location = useLocation();
    const {error: isBadCredential} = parse(location.search);

    const passwordInputField = () => {
        const [action, inputType, Icon] = masked ? ['Show', 'password', RemoveRedEye] : ['Hide', 'text', EyeOff];

        return (
            <InputTextField
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title={`${action} password`}>
                                <IconButton className={classes.eye} onClick={() => setMasked(!masked)}>
                                    <Icon />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                }}
                autoComplete="current-password"
                label="Password"
                name="password"
                type={inputType}
                value={password}
                onChange={e => setPassword(e.target.value)}
            />
        );
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.card}>
                <img alt="ripple logo" src={logo} />
                {isBadCredential ? (
                    <Typography className={classes.error} variant="body1">
                        Invalid login credentials &#9785;
                    </Typography>
                ) : null}
                <form
                    action={`${Config.login.oauthBaseUrl}${Config.login.loginUrl}`}
                    className={classes.form}
                    method="POST"
                    noValidate={true}
                >
                    <InputTextField
                        autoComplete="username"
                        autoFocus={true}
                        label="Username"
                        name="username"
                        type="username"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                    />
                    {passwordInputField()}
                    <input name="_csrf" type="hidden" value={cookie.load(Config.login.csrfTokenCookieName)} />
                    <Button
                        className={classes.submit}
                        color="primary"
                        disabled={username === '' || password === ''}
                        fullWidth={true}
                        type="submit"
                        variant="contained"
                        onClick={() => localStorage.removeItem('sessionExpireTime')}
                    >
                        Sign In
                    </Button>
                    <Link to="/forgot-password">Forgot password?</Link>
                </form>
            </div>
        </Container>
    );
};

export default Login;
